import request from '@/utils/request'

export function sendCode(phone) {
  return request.post('/auth/send-code', { phone, scene: 'register' })
}

export function register(data) {
  return request.post('/auth/register', data)
}

export function getInviterInfo(inviteCode) {
  return request.get(`/h5/user/by-invite-code/${encodeURIComponent(inviteCode)}`)
}

export function getAgreement(key) {
  return request.get(`/app-agreement/use/${key}`)
}

export function getDownloadInfo() {
  return request.get('/h5/apk-url')
}
